import script from "./Callback.vue?vue&type=script&setup=true&lang=ts"
export * from "./Callback.vue?vue&type=script&setup=true&lang=ts"

import "./Callback.vue?vue&type=style&index=0&id=21462cdb&lang=scss&scoped=true"

import exportComponent from "X:\\Git\\Patreon-Linker\\patreon-linker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21462cdb"]])

export default __exports__